/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BillIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABEklEQVR4nO2UwU7DMAyG9wIDDR6DaeOMxr1TEtvRlNjZxCOz887Ae4As1g0aQilrEYdZ8iFO8392amc0Otu/MPBigOQFSF77cIf8bImXB4AG+hKHGkLydKxgH0TkO10bH6edBZ3c6FlLaVHHMkC9Nj7OuwKMj/OS3iGgmSOubx3xtlmuxbQCgLG6xUSOZPf5G97q2Y/VZ4DSXYYQrpqNYcx6onvfnf0RwGJalbuPw8kAABiXAFW1uRgUEEK47OOKqARwJPFkgCPZ6Q9tihM9XLcNaAbQYdF+/qpNwXPQO1fXzDNxlEfnZKYarYOm/TzIoFlKi98+FcbH6XtyfJ8BBn/sLPGybSqho7jzUpW672x/a2+AxTQDr8MUJwAAAABJRU5ErkJggg==)
 */
export const BillIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M3 4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H3Zm9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM3 7a1 1 0 0 1 1-1h1.25c.41 0 .75.34.75.75C6 7.99 5 9 3.75 9A.75.75 0 0 1 3 8.25V7Zm1 11a1 1 0 0 1-1-1v-1.25c0-.41.34-.75.75-.75C4.99 15 6 16 6 17.25c0 .41-.34.75-.75.75H4ZM21 7a1 1 0 0 0-1-1h-1.25a.75.75 0 0 0-.75.75C18 7.99 19 9 20.25 9c.41 0 .75-.34.75-.75V7Zm-1 11a1 1 0 0 0 1-1v-1.25a.75.75 0 0 0-.75-.75C19.01 15 18 16 18 17.25c0 .41.34.75.75.75H20Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
